<template>
    <router-view></router-view>
</template>

<script>
/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application
 */
export default {
  /**
   * The name of the application.
   */
  name: 'desk-rh-admin',

};
</script>



// WEBPACK FOOTER //
// src/App.vue